angular.module('app.catalogo').factory('fgtsSaqAnivFactory', function ($http, SweetAlert) {
    var _apiName = 'FGTSSaqAniv';

    var _buscarPropostas = function (options, dtInicio, dtTermino, cpfTrabalhador, nomeParceiro, codigoPropostaAN, identificadorSolicitacao) {

        var dto = options.data;

        dto.parms = [];
        dto.parms.push({ "name": "DtInicio", "value": dtInicio });
        dto.parms.push({ "name": "DtTermino", "value": dtTermino });
        dto.parms.push({ "name": "CPFTrabalhador", "value": cpfTrabalhador });
        dto.parms.push({ "name": "CodigoPropostaAN", "value": codigoPropostaAN });
        dto.parms.push({ "name": "NomeParceiro", "value": nomeParceiro });
        dto.parms.push({ "name": "IdentificadorSolicitacao", "value": identificadorSolicitacao });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/BuscaPropostas', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            SweetAlert.swal({
                title: "",
                text: response.data.Messages[0].Description,
                showCancelButton: false,
                confirmButtonText: "OK",
                closeOnConfirm: true
            });
        });

    };

    var _listarParceiros = function (search) {
        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "id", "value": search });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/BuscaParceiros', dto);
    }

    var _obterParceiroByCodigoRedeLoja = function (codigoRedeLoja) {
        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigoRedeLoja", "value": codigoRedeLoja });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ObterParceiro', dto);
    }


    var _adicionarCampoMaxMinAoResultado = function (responseTaxas) {
        let taxas = responseTaxas.Data;
        if (!(taxas && taxas.length > 0)) {
            return responseTaxas;
        }

        let minTax = Infinity;
        let maxTax = -Infinity;
        taxas.sort(function (a, b) {
            return b.PercMensal - a.PercMensal;
        });

        taxas.forEach(function (taxa) {
            if (taxa.PercMensal < minTax) {
                minTax = taxa.PercMensal;
            }
            if (taxa.PercMensal > maxTax) {
                maxTax = taxa.PercMensal;
            }
        });
        taxas.forEach(function (taxa) {
            if (taxa.PercMensal === minTax) {
                taxa.TipoTaxa = 1;  // Taxa minima
            } else if (taxa.PercMensal === maxTax) {
                taxa.TipoTaxa = 2;  // Taxa maxima
            } else {
                taxa.TipoTaxa = 0;  // Valor default
            }
        });

        return responseTaxas;
    };

    var _buscarTaxas = function (options, codigoProdutoRede) {

        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigoProdutoRede", "value": codigoProdutoRede });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/BuscaTaxas', dto).then(function (response) {
            response.data = _adicionarCampoMaxMinAoResultado(response.data);
            options.success(response.data);
        }, function (response) {
            SweetAlert.swal({
                title: "",
                text: response.data.Messages[0].Description,
                showCancelButton: false,
                confirmButtonText: "OK",
                closeOnConfirm: true
            });
        });

    }

    var _excluirTaxa = function (codigoProdutoRede, percTaxa) {
        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigoProdutoRede", "value": codigoProdutoRede });
        dto.parms.push({ "name": "PercTaxa", "value": percTaxa });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ExcluiTaxa', dto)
    }

    var _tornarTaxaPadrao = function (codigoProdutoRede, codigo) {
        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigoProdutoRede", "value": codigoProdutoRede });
        dto.parms.push({ "name": "Codigo", "value": codigo });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/TornarTaxaPadrao', dto)
    }

    var _incluirTaxa = function (options, codigoProdutoRede, percTaxa) {

        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigoProdutoRede", "value": codigoProdutoRede });
        dto.parms.push({ "name": "PercTaxa", "value": percTaxa });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/IncluiTaxa', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            SweetAlert.swal({
                title: "",
                text: response.data.Messages[0].Description,
                showCancelButton: false,
                confirmButtonText: "OK",
                closeOnConfirm: true
            });
        });
    }

    var _listarRequisicao = function (dtInicio, dtTermino, codigoLog) {

        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "DtInicio", "value": dtInicio });
        dto.parms.push({ "name": "DtTermino", "value": dtTermino });
        dto.parms.push({ "name": "CodigoLog", "value": codigoLog });
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListaRequisicoes', dto)

    };

    var _listarEnvio = function (LogId) {

        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "LogId", "value": LogId });
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListaEnvio', dto)

    };

    var _realizarCancelamento = function (codigoSolicTrava, codigoIntegracao, cpfTrabalhador) {

        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigoSolicTrava", "value": codigoSolicTrava });
        dto.parms.push({ "name": "CodigoIntegracao", "value": codigoIntegracao });
        dto.parms.push({ "name": "CPFTrabalhador", "value": cpfTrabalhador });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/RealizaCancelamento', dto);
    };

    var _pertenceFGTSSaqAniv = function (codigoProposta) {

        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigoProposta", "value": codigoProposta });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/PertenceFGTSSaqAniv', dto);
    };

    var _listarParceiros = function (search) {
        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "NomeParceiro", "value": search });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/BuscaParceiros', dto);
    }

    var _consultaTrava = function (cpfTrabalhador, codigoProposta, codigoIntegracao, codigoSolicTrava) {
        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CpfTrabalhador", "value": cpfTrabalhador });
        dto.parms.push({ "name": "CodigoProposta", "value": codigoProposta });
        dto.parms.push({ "name": "CodigoIntegracao", "value": codigoIntegracao });
        dto.parms.push({ "name": "CodigoSolicTrava", "value": codigoSolicTrava });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ConsultaTrava', dto);
    }

    var _reprocessaTrava = function (codigoProposta, codigoSolicTrava) {
        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigoProposta", "value": codigoProposta });
        dto.parms.push({ "name": "CodigoSolicTrava", "value": codigoSolicTrava });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ReprocessaTrava', dto);
    }

    var _saveCredencialAverbacao = function (options, codigoProdutoRede, credencial, ativo) {
        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigoProdutoRede", "value": codigoProdutoRede });
        dto.parms.push({ "name": "EPCodigoRebalancamento", "value": credencial });
        dto.parms.push({ "name": "Ativo", "value": ativo });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/SalvarCredencialAverbacao', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            SweetAlert.swal({
                title: "",
                text: response.data.Messages[0].Description,
                showCancelButton: false,
                confirmButtonText: "OK",
                closeOnConfirm: true
            });
        });
    };

    var _buscaCredencialAverbacao = function (codigoProdutoRede) {
        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigoProdutoRede", "value": codigoProdutoRede });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/BuscarCredencialAverbacao', dto);
    };

    var _listarHistoricoControleCancelamento = function (options, dtInicio, dtTermino, redeLoja, responsavel, search) {
        var dto = {};
        dto.parms = [];
        dto.search = search;
        dto.parms.push({ "name": "DtInicio", "value": dtInicio });
        dto.parms.push({ "name": "DtTermino", "value": dtTermino });
        dto.parms.push({ "name": "RedeLoja", "value": redeLoja });
        dto.parms.push({ "name": "Responsavel", "value": responsavel });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListaHistoricoControleCancelamento', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            SweetAlert.swal({
                title: "",
                text: response.data.Messages[0].Description,
                showCancelButton: false,
                confirmButtonText: "OK",
                closeOnConfirm: true
            });
        });
    };

    var _cancelarPropostaManual = function (codigoProposta, motivoCancelamento) {

        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "CodigoPropostaAN", "value": codigoProposta });
        dto.parms.push({ "name": "MotivoCancelamento", "value": motivoCancelamento });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/CancelarPropostaManual', dto);
    };

    var _listAllRedesLoja = function () {

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListAllRedesLoja');
    };

    var _listAllResponsaveis = function () {

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListAllResponsaveis');
    };

    var _listarParceiros = function (search) {
        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "NomeParceiro", "value": search });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/BuscaParceiros', dto);
    }

    var factory = {};

    factory.buscarPropostas = _buscarPropostas;
    factory.realizarCancelamento = _realizarCancelamento;
    factory.listarRequisicao = _listarRequisicao;
    factory.listarEnvio = _listarEnvio;
    factory.pertenceFGTSSaqAniv = _pertenceFGTSSaqAniv;
    factory.listarParceiros = _listarParceiros;
    factory.buscarTaxas = _buscarTaxas;
    factory.tornarTaxaPadrao = _tornarTaxaPadrao;
    factory.excluirTaxa = _excluirTaxa;
    factory.incluirTaxa = _incluirTaxa;
    factory.consultaTrava = _consultaTrava;
    factory.reprocessaTrava = _reprocessaTrava;
    factory.obterParceiroByCodigoRedeLoja = _obterParceiroByCodigoRedeLoja;
    factory.saveCredencialAverbacao = _saveCredencialAverbacao;
    factory.buscaCredencialAverbacao = _buscaCredencialAverbacao;
    factory.listarHistoricoControleCancelamento = _listarHistoricoControleCancelamento;
    factory.cancelarPropostaManual = _cancelarPropostaManual;
    factory.listAllRedesLoja = _listAllRedesLoja;
    factory.listAllResponsaveis = _listAllResponsaveis;

    return factory;

});